import { z } from 'zod/v4';
import { Brand } from '../../branded-types';

export type ConfigurationGroupId = Brand<string, 'configurationGroupId'>;

export interface IConfigurationGroup {
  id?: ConfigurationGroupId;
  label: string;
  description: string;
}

export const CONFIGURATION_GROUP_SCHEMA: z.ZodType<IConfigurationGroup> =
  z.object({
    id: z
      .uuid()
      .transform((id: string) => id as ConfigurationGroupId)
      .optional(),
    label: z.string(),
    description: z.string(),
  });

export const CONFIGURATION_GROUPS = {
  Registration: {
    id: '657d652f-6d22-4f2d-93d3-afba50568e42' as ConfigurationGroupId,
    label: 'Registrierung',
    description: '',
  },
  LoginLogout: {
    id: 'dd7f3205-e153-48cf-acbf-d402e482a983' as ConfigurationGroupId,
    label: 'Login/Logout',
    description: '',
  },
  PersonalArea: {
    id: '74f305fe-ea97-4271-a245-2b281061a467' as ConfigurationGroupId,
    label: 'Persönlicher Bereich',
    description: '',
  },
  ProofOfPurchase: {
    id: 'e7951b96-2c5c-4722-b861-8f680326178b' as ConfigurationGroupId,
    label: 'Versand Kaufbeleg',
    description: '',
  },
  EmailNotifications: {
    id: '31e33224-ec32-48c7-a06e-1da210ec9a9e' as ConfigurationGroupId,
    label: 'E-Mail-Benachrichtigungen',
    description: 'E-Mail Templates bei Notify',
  },
  RelationSale: {
    id: 'c3e11aec-1cc8-48c0-9a3d-c00db2922a9f' as ConfigurationGroupId,
    label: 'Relationsverkauf',
    description: '',
  },
  ShoppingCart: {
    id: '9b613ad1-0285-4790-bdbe-7756825d61bc' as ConfigurationGroupId,
    label: 'Warenkorb',
    description: '',
  },
  AlternativePassengerData: {
    id: 'f18363d1-9e88-441a-8855-9c5ae1b85b35' as ConfigurationGroupId,
    label: 'Alternative Passagierdaten',
    description: '',
  },
  Shibboleth: {
    id: '8a024937-498e-4e9f-8f61-cc73e8632467' as ConfigurationGroupId,
    label: 'Shibboleth',
    description: '',
  },
  CancellationWithoutLogin: {
    id: '9dafed0d-7c05-467b-8913-52825f957945' as ConfigurationGroupId,
    label: 'Kündigung ohne Login',
    description: '',
  },
} as const satisfies Record<string, IConfigurationGroup>;

export const DEFAULT_CONFIGURATION_GROUPS: IConfigurationGroup[] =
  Object.values(CONFIGURATION_GROUPS);
